"use client";

import React from "react";
import { Card, CardFooter, Avatar, Button, Image, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Chip, user } from "@nextui-org/react";


import { Job } from "@/types/types";

interface FeaturesTableProps {
    job: Job;
}

const AvantagesInconvenients: React.FC<FeaturesTableProps> = ({ job }) => {
    return (
        <Table aria-label="Avantages - Inconvenients">
            <TableHeader>
                <TableColumn className="text-center text-white bg-black">AVANTAGES</TableColumn>
                <TableColumn className="text-center  text-white bg-black">INCONVÉNIENTS</TableColumn>
            </TableHeader>
            <TableBody>
                <TableRow key="1">
                    <TableCell className="text-center">
                        <Chip className="capitalize" color="success" size="sm" variant="flat">
                            {job.Avantage1}
                        </Chip>
                    </TableCell>
                    <TableCell className="text-center">
                        <Chip className="capitalize" color="danger" size="sm" variant="flat">
                            {job.Inconvenient1}
                        </Chip>
                    </TableCell>
                </TableRow>
                <TableRow key="2">
                    <TableCell className="text-center bg-elevation-1">
                        <Chip className="capitalize" color="success" size="sm" variant="flat">
                            {job.Avantage2}
                        </Chip>
                    </TableCell>
                    <TableCell className="text-center bg-elevation-1">
                        <Chip className="capitalize" color="danger" size="sm" variant="flat">
                            {job.Inconvenient2}
                        </Chip>
                    </TableCell>
                </TableRow>
                <TableRow key="3">
                    <TableCell className="text-center">
                        <Chip className="capitalize" color="success" size="sm" variant="flat">
                            {job.Avantage3}
                        </Chip>
                    </TableCell>
                    <TableCell className="text-center">
                        <Chip className="capitalize" color="danger" size="sm" variant="flat">
                            {job.Inconvenient3}
                        </Chip>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}

export default AvantagesInconvenients;